module.exports = __webpack_public_path__ + "3722fa3501a773875c2f52f5cb3199ce.png";


//////////////////
// WEBPACK FOOTER
// ./src/logos/uuum.png
// module id = 85
// module chunks = 0